import { uid } from 'radash';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    hasBidirectionalProtectionOnUnidirectionalFlow,
    isProtectionDevice,
} from 'models';

const protectionDirectionality: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const { componentInstances, connections } = diagram;

    const errors: ComponentInstanceValidationError[] = [];

    const connectedComponentInstanceIds = new Set(
        Object.values(connections).flatMap((connection) => [
            connection.from.componentInstanceId,
            connection.to.componentInstanceId,
        ]),
    );

    Object.values(componentInstances).forEach((componentInstance) => {
        if (componentInstance.disabled || !isProtectionDevice(componentInstance.componentType)) {
            return;
        }

        if (!connectedComponentInstanceIds.has(componentInstance.id)) {
            return;
        }

        if (!hasBidirectionalProtectionOnUnidirectionalFlow(componentInstance)) {
            return;
        }

        errors.push({
            type: ComponentInstanceValidationErrorType.PROTECTION_DIRECTION_BIDIRECTIONAL_ON_UNIDIRECTIONAL_FLOW,
            level: 'error',
            payload: { componentInstance },
            id: uid(6),
        });
    });

    return errors;
};

export { protectionDirectionality };
